import { FETCH_IMPRESSUM } from "../actions/type";

const initState = {
  empty: true
};

export default function(state = initState, action) {
  switch (action.type) {
    case FETCH_IMPRESSUM:
      return action.data;
    default:
      return state;
  }
}
